'use client';
import Head from 'next/head';
import { useState, useMemo } from 'react';
import { TallyIcon } from '@/components/icons';
import MethodPageLayout from '@/components/layouts/MethodPageLayout';
import TallyMarkVisualiser from '@/components/methods/TallyMarkVisualiser';
import SliderControl from '@/components/common/SliderControl';
import StepperControl from '@/components/common/StepperControl';
import ColorSwatchRow from '@/components/common/ColorSwatchRow';

const TALLY_COLORS = ['#1a1a18', '#534AB7', '#0F6E56', '#185FA5', '#993C1D', '#854F0B'];

export default function TallyMarkPage() {
    const [count, setCount] = useState(12);
    const [strokeColor, setStrokeColor] = useState('#185FA5');
    const [strokeWidth, setStrokeWidth] = useState(2);

    const onReset = () => {
        setCount(12);
        setStrokeColor('#185FA5');
        setStrokeWidth(2);
    };

    const options = useMemo(
        () => ({
            strokeColor,
            strokeWidth: strokeWidth || 2,
        }),
        [strokeColor, strokeWidth],
    );

    const controls = (
        <>
            <SliderControl
                label="Number to Visualise"
                value={count}
                min={0}
                max={500}
                onChange={setCount}
            />
            <StepperControl
                label="Stroke Width"
                value={strokeWidth}
                min={1}
                max={10}
                onChange={setStrokeWidth}
            />
            <ColorSwatchRow
                label="Line Color"
                colors={TALLY_COLORS}
                value={strokeColor}
                onChange={setStrokeColor}
            />
        </>
    );

    return (
        <>
            <Head>
                <title>Tally Mark Visualiser</title>
            </Head>
            <MethodPageLayout
                icon={<TallyIcon size={20} />}
                iconColor="blue"
                title="Tally marks"
                description="Visualise numbers using tally marks."
                category="visualiser"
                controls={controls}
                onReset={onReset}
            >
                <TallyMarkVisualiser count={count} options={options} />
            </MethodPageLayout>
        </>
    );
}
